// eslint-disable-next-line import/prefer-default-export
export const removeItemFromArray = (array, n) => {
    const index = array.indexOf(n);

    // if the element is in the array, remove it
    if (index > -1) {
        // remove item
        array.splice(index, 1);
    }
    return array;
};

export const checkIsValidArray = (arr = []) => {
    if (Array.isArray(arr) && arr.length > 0) return true;
    return false;
};

export const getCodeValue = (data = [], matchKey = '', value, returnKey = '') => {
    if (data?.length > 0 && matchKey && returnKey) {
        return data?.find((item) => item?.[matchKey] === Number(value) || item?.[matchKey] === value)?.[returnKey] || value;
    }
    return value;
};

export const isEmptyArray = (arr = []) => {
    if (Array.isArray(arr) && arr.length === 0) return true;
    return false;
};
